export enum WeaponType {
    Rock = 0,
    Boomerang = 1,
    Ball = 3,
    Dynamite = 4,
}
